import type { AttributeProps } from '../Attribute/Attribute.types';
import type { BadgeProps } from '../Badge/Badge.types';
import type { ButtonProps } from '../Button/Button.types';
import type { FeedbackMessageProps } from '../FeedbackMessage/FeedbackMessage.types';

export type InformativeCardFeedbackProps = Omit<
  FeedbackMessageProps,
  'mode' | 'fullWidth' | 'buttonText'
>;

export const InformativeCardBackground = {
  BASE: 'base',
  RAISED: 'raised',
  SUBTLE: 'subtle',
  IDLE: 'idle',
} as const;

export type InformativeCardBackgroundType =
  (typeof InformativeCardBackground)[keyof typeof InformativeCardBackground];

export const InformativeCardLeadingSize = {
  AUTO: 'auto',
  BANNER: 'banner',
  PREVIEW: 'preview',
} as const;

export type InformativeCardLeadingSizeType =
  (typeof InformativeCardLeadingSize)[keyof typeof InformativeCardLeadingSize];

export type InformativeCardActionProps = ButtonProps & {
  label?: string;
};

export type InformativeCardProps = {
  highlighted?: boolean;
  padded?: boolean;
  backgroundColor?: InformativeCardBackgroundType;
  title?: string;
  description?: string;
  badge?: BadgeProps;
  attributes?: AttributeProps[];
  expandAttributes?: boolean;
  feedbackMessage?: InformativeCardFeedbackProps;
  leadingSrc?: string;
  leadingAlt?: string;
  leadingSize?: InformativeCardLeadingSizeType;
  action?: InformativeCardActionProps;
  actions?: InformativeCardActionProps[];
  headerActions?: InformativeCardActionProps[];
  testId?: string;
};
